import React from 'react';

interface GafnirLogoProps {
  className?: string;
  width?: number;
}

const GafnirLogo: React.FC<GafnirLogoProps> = ({ className = '', width = 180 }) => {
  return (
    <img
      src="/gafnir-dragon.png"
      alt="Gafnir Logo"
      width={width}
      height={width}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default GafnirLogo; 